// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from 'E:/IdeaProjects/Creche/ParentZone/client/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelPublic0 from 'E:/IdeaProjects/Creche/ParentZone/client/src/models/public.ts';
import ModelUser1 from 'E:/IdeaProjects/Creche/ParentZone/client/src/models/user.ts';
import ModelFormModels2 from 'E:/IdeaProjects/Creche/ParentZone/client/src/pages/foster-service/models/formModels.ts';
import ModelStepModels3 from 'E:/IdeaProjects/Creche/ParentZone/client/src/pages/foster-service/models/stepModels.ts';
import ModelFormModels4 from 'E:/IdeaProjects/Creche/ParentZone/client/src/pages/service-step/models/formModels.ts';
import ModelStepModels5 from 'E:/IdeaProjects/Creche/ParentZone/client/src/pages/service-step/models/stepModels.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'public', ...ModelPublic0 });
app.model({ namespace: 'user', ...ModelUser1 });
app.model({ namespace: 'formModels', ...ModelFormModels2 });
app.model({ namespace: 'stepModels', ...ModelStepModels3 });
app.model({ namespace: 'formModels', ...ModelFormModels4 });
app.model({ namespace: 'stepModels', ...ModelStepModels5 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
